(function () {
  function reveal(root) {
    var targets = (root || document).querySelectorAll('.fu:not(.in)');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  reveal(document);

  // テーマエディタでセクションを編集・追加したときに再適用する
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();
